import { useMutation } from "@apollo/client";

import { MapEditorEcologicalFunctionPanel_EcologicalFunctionObservationDeleteDocument } from "./mutations.generated";
import { MapEditorEcologicalFunctionPanelEcologicalFunctionEditableDocument } from "./queries.generated";

export function useUnlinkObservationFromEcologicalFunctionMutation() {
    const [mutate, result] = useMutation(MapEditorEcologicalFunctionPanel_EcologicalFunctionObservationDeleteDocument, {
        refetchQueries: [MapEditorEcologicalFunctionPanelEcologicalFunctionEditableDocument],
    });

    const unlinkObservationFromEcologicalFunction = (ecologicalFunctionId: string, observationId: string) =>
        mutate({
            variables: {
                input: {
                    ecologicalFunctionId,
                    observationId,
                },
            },
        });

    return [unlinkObservationFromEcologicalFunction, result] as const;
}
